import { useEffect } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { useHistory } from "react-router-dom";

const RedirectHandler = () => {
  const { user, isAuthenticated, isLoading } = useAuth0();
  const history = useHistory();

  useEffect(() => {
    if (isLoading || !isAuthenticated) {
      return;
    }

    const shouldRedirect = localStorage.getItem("postLoginRedirect");

    if (shouldRedirect) {
      localStorage.removeItem("postLoginRedirect");

      const displayId =
        user?.[`${process.env.REACT_APP_AUDIENCE}/fixed_stations_display_id`];
      const interval = user?.[`${process.env.REACT_APP_AUDIENCE}/interval`];

      if (displayId) {
        history.push(
          `/data-access/system-graphs/fixed-stations/${displayId}?interval=${interval}`
        );
      } else {
        history.push("/dashboard");
      }
    }
  }, [user, isAuthenticated, isLoading, history]);

  return null;
};

export default RedirectHandler;
